import React, { useState } from 'react';
import { Popover } from 'antd';

export const ComparisonSection = () => {


    const data = {
        article: {
            content: `Honey bees are social insects that live in `,
            title: '18-1-1',
        },
        article2: {
            content: `The Late Bronze Age collapse was a Honey transition period in the Near East and Eastern Mediterranean. Honey bees are social insects that live in `,
            title: '18-1-2',
        },
        commonWords: ["Honey"]
    }



    const { article: article1, article2, commonWords } = data;


    const article2Name = '18-1-2';
    const [hovered, setHovered] = useState<string | null>(null);

    const compileContent = (content: string) => {

        return content.split(" ").map((word, i) => {
            const contentLength = content.split(" ").slice(0, i).join(" ").length
            const isCommon = commonWords.includes(word);
            const offset = contentLength + (i > 0 ? 1 : 0);
            const startIndex0 = offset; // 0-based start
            const endIndex0 = startIndex0 + word.length - 1; // 0-based end
            const startPos = startIndex0; // 1-based start position
            const endPos = endIndex0 + 1; // 1-based end position
            /*
        {word:"horney",
        article_id:"18-1-2",
        art_indexs:[23,32]
        }

            */
            const wordData = {
                word: "Honey",
                definition: "A sweet, viscous food substance made by bees and some related insects.",
                sentence: "Honey bees are social insects that live in ",
                occur_count: 5,
                alsoUsedIn: [{ sentence: "I love honey", articleId: "剑17-1-3" },
                { sentence: "We do not like honey", articleId: "剑17-1-4" }],
            }

            const popoverContent = (
                <div>
                    <p style={{ fontStyle: 'italic' }}>{wordData.definition}</p>
                    <p>{`"` + wordData.sentence + `"`}</p>
                    <p>{`Appeared in other ${wordData.occur_count} articles:`}</p>
                    <ul>
                        {wordData.alsoUsedIn.map((item, i) => (
                            <li key={i}>{`"${item.sentence}"  - ${item.articleId}`}</li>
                        ))}
                    </ul>
                </div>
            );

            return (
                <Popover content={popoverContent} title={word} trigger="click" key={i}>
                    <span
                        className={`highlight-${word}`}       // key 如 commonWord.word.replace(/\s+/g,'-')
                        onMouseEnter={() => setHovered(word)}
                        onMouseLeave={() => setHovered(null)}
                        style={{ backgroundColor: hovered === word && isCommon ? 'yellow' : isCommon && 'bisque' }}
                    >
                        {word + (isCommon ? '' : ' ')}
                    </span>
                    {isCommon ? ' ' : ''}
                </Popover>
            );
        })
    };

    let article1Content = compileContent(article1.content);
    let article2Content = compileContent(article2.content);

    return (
        // set a constrained height so children with `overflow` can scroll independently
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px', textAlign: 'justify', paddingRight: '30px', height: 'calc(100vh - 160px)' }}>
            <div style={{ overflowY: "auto", flex: 1, minHeight: 0, paddingRight: '15px', }} >{article1Content}</div>
            <div style={{ overflowY: "auto", flex: 1, minHeight: 0, paddingRight: '15px', }} >{article2Content}</div>
        </div>
    );
}